import {styled} from "@mui/material";
import List from "@mui/material/List";
import CircularProgress from "@mui/material/CircularProgress";
import Chip from "@mui/material/Chip";

export const TemplateList = styled(List)(
  () => ({
    maxHeight: "25rem",
    minWidth: "20rem",
    overflowY: "auto",
  }));

export const TemplateLoader = styled(CircularProgress)(
  ({ theme }) => ({
    color: theme.palette.primary.main,
    margin: theme.spacing(2),
  }));

export const FeeScheduleTagChip = styled(Chip)(
  ({ theme }) => ({
    color: "#777",
    marginRight: theme.spacing(0.25),
  }));
